<template>
  <element>
    <nav-breadcrumb :menu="[{label: '贷款业务 '}, {label: '发起签约 '}]"/>
    <div class="xzpadd10 bg-purple of">
        <form-build
          :form-data="financingDetail"
          :form-rules="financingRules"
          :form-columns="financingColumns"
          class="formTable"
          form-name="formSubmit1" ref="formBuildName1"
        />
        <panel label="房屋信息">
            <el-checkbox false-label="N" true-label="Y" v-model="financingDetail.fidoc__splitWarrant"  label="拆分抵押合同" v-if="((financingDetail||{}).properties||[]).length>1">拆分抵押合同</el-checkbox>
            <panel :label="'抵押物'+(idx+1)"  v-for="(item, idx) in ((financingDetail||{}).properties||[])" :key="idx" >
            <!--  <form-build
                :form-data="item"
                :form-rules="financingRules"
                :form-columns="houseColumns"
                class="formTable"
                form-name="formSubmit2" ref="formBuildName2"
              />-->


                    <el-form :model="item"  :rules="Form" label-width="150px"  ref="formBuildName2"  class="formTable">
                        <el-row style="margin:0;">
                            <el-col :span="12">
                                <el-form-item label="权属：">
                                    {{item.pr__propertyOwner}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="位置：">
                                    {{item.pr__propertyLocation}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="用途：" >
                                    {{item.pr__propertyUsage}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="面积：" >
                                    {{item.pr__propertyArea}}㎡
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="产权证号：">
                                    {{item.pr__propertyCertNo}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="土地证：" >
                                    {{item.pr__propertyLandNo}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="土地使用权面积：" >
                                    {{item.pr__propertyLandArea}}㎡
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="债权最高本金余额：">
                                    {{Math.floor((item.asm__nominalTotalValue-item.asm__pledgeRightsAmount)/10000)*10000|formatMoney(0)}}元
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="暂作价：" >
                                    {{Math.floor((item.asm__nominalTotalValue)/10000)*10000|formatMoney(0)}}元
                                </el-form-item>
                            </el-col>

                            <el-col :span="24">
                                <el-form-item label="担保合同编号：" prop="doc__warrantNo"  :rules="{required:true, message: '担保合同编号不能为空'}" >
                                    <el-row>
                                        <el-col :span="6">
                                            <el-radio-group v-model="financingDetail.properties[idx].doc__exWarrant">
                                                <el-radio   label="N">新抵押合同</el-radio>
                                                <el-radio   label="Y">选择已有抵押合同</el-radio>
                                            </el-radio-group>
                                        </el-col>
                                        <el-col :span="10">
                                            <el-input  v-model="financingDetail.properties[idx].doc__warrantNo" ></el-input>
                                        </el-col>
                                        <el-col :span="8">
                                            &nbsp;&nbsp;&nbsp;<el-button type="small" @click="onSelect(idx)" v-if="item.doc__exWarrant=='Y'">选择</el-button>
                                        </el-col>
                                    </el-row>


                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="抵押期限：" prop="doc__pledgeFr" :rules="{required: true, message: '不能为空'}">
                                    <el-date-picker
                                        v-model="financingDetail.properties[idx].doc__pledgeFr"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期"
                                        start-placeholder=""
                                        :picker-options="{
                                            disabledDate: time => {
                                                  return time.getTime() >   Number($moment(financingDetail.fi__startDate)||0)
                                          }
                                        }" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="至" prop="doc__pledgeTo" :rules="{required: true, message: '不能为空'}">
                                    <el-date-picker
                                            v-model="financingDetail.properties[idx].doc__pledgeTo"
                                        value-format="yyyy-MM-dd"
                                        type="date"
                                        placeholder="选择日期"
                                        :picker-options="{
                                            disabledDate: time => {
                                                  return time.getTime() <   Number($moment(financingDetail.fi__endDate)||0)
                                          }
                                        }"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="备注：" :rules="{required: ((financingDetail||{}).properties||[])[idx].asm__pledgeGrade=='一抵'?false:true, message: '备注不能为空'}" >
                                    <el-input  v-model="financingDetail.properties[idx].doc__remarks" type="textarea" :disabled="financingDetail.fidoc__splitWarrant=='N'&&idx>0"></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </el-form>
            </panel>
                <!--<el-form  :model="financingDetail"  ref="formBuildName2" :rules="remarksRules" label-width="150px">
                    <el-row :gutter="10" class="bg-purple xamhtrpg">
                        <el-col :span="24">
                            <el-form-item label="备注：" style="width: 60%" :rules="{required: ((financingDetail||{}).properties||[]).length==1&&((financingDetail||{}).properties||[])[0].asm__pledgeGrade=='一抵'?false:true, message: '备注不能为空'}" >
                                <el-input  v-model="financingDetail.fi__remarks" type="textarea"></el-input>{{financingDetail.asm__pledgeGrade}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>-->
        </panel>
      <panel v-for="(item, idx) in financingDetail.coborrowers" :key="idx">
        <el-checkbox true-label="true" false-label="false" :label="'共借人'+(idx+1)" v-model="item.co__checked" disabled></el-checkbox>
        <panel class="zhengjianxinxi">
        <form-build
          :form-data.sync="item"
          :form-rules="coRules"
          :form-columns="coColumns"
          class="formTable"
          v-if="item.co__checked"
        />
        </panel>
        <panel class="zhengjianxinxi">
        <photo-browser v-model="item.co__borrowerICFront" type='image' label="本人身份证正面" v-if="item.co__checked"/>
        <photo-browser v-model="item.co__borrowerICBack" type='image' label="本人身份证反面" v-if="item.co__checked"/>
            <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="item.co__borrowerHukou1" :editable="false" ></file-upload>户口本</div>
        </panel>
      </panel>
       <!-- <panel label="他项权证" class="zhengjianxinxi">
          <div class="zhenjianyyzz zhenjianyyzz2">
            <image-upload  v-model="financingDetail.fidoc__hisWarrant" prefix="images/"></image-upload>
            <label>他项权证</label>
          </div>
        </panel>-->

        <panel title="">
         <!-- <files-data-table :files="financingDetail.files"></files-data-table>-->
          <files-upload :file-list.sync="fileList"></files-upload>
        </panel>
    </div>
    <div class="tr xzmt">
        <el-button type="primary" @click="onSubmit()">确认提交</el-button>
        <el-button @click="$router.back()">取消</el-button>
    </div>
      <el-dialog
          title="选择"
          :visible.sync="dialogVisible" @close="dataRelaod()">
          <data-table
              :table-data="financing"
              :columns="selectColumns"
              :page.sync="pageMatching"
              :pageSize.sync="pageSizeMatching"
              :filters.sync="filtersMatching"
              :actions="actionsMatching"
              :isPaginationShow="false"
          />
      </el-dialog>
    </element>
</template>

<script>
  import xhr from '../../utils/xhr'
  import {formatMoney} from "../../filters/CommonFilters";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
    export default {
        name: "FinancingAdd",
      data(){
          return {
              dialogVisible:false,
              financing:{},
              pageMatching: 1,
              pageSizeMatching: 20,
              actionsMatching: [
              ],
              payAccountOptions:[],
              Form:{},
              filtersMatching: {
                  labelWidth: '150px',
                  form: {
                      fi__transactionNo:'',
                  },
                  columns: [
                      {
                          label: '抵押合同',
                          component: 'el-input',
                          field: 'fi__transactionNo'
                      },

                  ],
                  onSubmit:()=>{
                      this.pageMatching = 1
                      this.onSelect(this.selectKeys)
                  }
              },
            coRules:{

            },
              selectColumns:[
                  {
                      label: '抵押合同',
                      field: 'doc__warrantNo',
                  },
                  {
                      label: '操作',
                      width: '180',
                      opts: [
                          {
                              label: '选择',
                              class: 'el-icon-finished',
                              clickHandler: (index, row) => {
                                    //console.log(((this.financingDetail||{}).properties||[]))
                                ((this.financingDetail||{}).properties||[])[this.selectKeys].doc__warrantNo=  row.doc__warrantNo
                                  this.selectKeys=-1
                                  this.dialogVisible = false
                              }
                          }]
                  }

              ],
              selectKeys:-1,
            coColumns:[
              {
                label: '与借款人关系',
                field: 'co__relationship',
              },
              {
                label: '姓名',
                field: 'co__borrowerName',
              },
              {
                label: '身份证号码',
                field: 'co__borrowerIC',
              },
              {
                label: '手机号',
                field: 'co__borrowerContactNo',
              },
              {
                label: '住所地址',
                field: 'co__borrowerAddress',
                span:24
              },
            ],
            applicationId: this.$route.query['applicationId']||'',
            unit:'',
            unit2:'',
            financingDetail :{
              't__applicationId': '',
              'fi__endDateFixed':'N',
              'p__productId': '',
              'cb__bank': '',
              'cb__accountNo': '',
              'cb__accountName': '',
              'fi__currencyCode': 'CNY',
              'fi__startDate': '',
              'fi__endDate': '',
              'fi__interestPayTime': '还款时收取',
              'fi__interestRate': '',
              'fi__interestType': 'Yearly',
              'fi__intendedUse': '',
              'fi__lendingFee': 0,
              'fi__lendingFeePayTime': '还款时收取',
              'fi__repaymentCount': '',
              'fi__repaymentFormula': '',
              'fi__remarks': '',
              'fi__totalAmount': '',
              'fi__transactionDate': '',
              'fi__transactionId': '',
              'fi__transactionStatus': 'Pending Approval',
              'fi__transactionNo': '提交时生成',
              'ex__purpose':'',
              'dfi__interestRate': '',
              'dfi__interestType': '',
              'fidoc__hisWarrant': '',
              'fidoc__warrantNo': '',
              'files': [],
              'fi__proxyPersonName':'',
              'properties':[{
                  doc__exWarrant : "",
                  doc__warrantNo : "",
                  doc__pledgeFr :null,
                  doc__pledgeTo : null,
                  doc__remarks : '',
              }]
            },
              remarksRules:{
                  /*fi__remarks: [
                      {
                          required: false,
                          message: '不能为空！'
                      }
                  ],*/
              },
            financingRules:{
            fi__proxyPersonName: [
                {
                    required: true,
                    message: '代理人不能为空！'
                }
            ],
              fi__penaltyInterestRate: [
                {
                  required: true,
                  message: '罚息复利率不能为空！'
                }
              ],
              ex__purpose: [
                {
                  required: true,
                  message: '贷款用途不能为空！'
                }
              ],
              fi__endDateFixed: [
                {
                  required: true,
                  message: '是否调整期限不能为空！'
                }
              ],
              fi__transactionNo: [
                {
                  required: true,
                  message: '贷款编号不能为空！'
                }
              ],
              fi__transactionStatus: [
                {
                  required: true,
                  message: '贷款状态不能为空！'
                }
              ],
              fi__totalAmount: [
                {
                  required: true,
                  message: '贷款金额不能为空！'
                }
              ],
              p__productId: [
                {
                  required: true,
                  message: '贷款产品不能为空！'
                }
              ],
              fi__startDate: [
                {
                  required: true,
                  message: '开始日期不能为空！'
                }
              ],
              fi__endDate: [
                {
                  required: true,
                  message: '结束日期不能为空！'
                }
              ],
              fi__transactionDate: [
                {
                  required: true,
                  message: '申请日期不能为空！'
                }
              ],
             /* fi__transactionDate: [
                {
                  required: true,
                  message: '申请日期不能为空！'
                }
              ],*/
              fi__interestRate: [
                {
                  required: true,
                  message: '贷款合同利率不能为空！'
                }
              ],
              dfi__interestRate: [
                {
                  required: true,
                  message: '留存收益率不能为空！'
                }
              ],
              fi__repaymentFormula: [
                {
                  required: true,
                  message: '还款方式不能为空！'
                }
              ],
              fi__repaymentCount: [
                {
                  required: true,
                  message: '还款期数不能为空！'
                }
              ],
              cb__accountNo: [
                {
                  required: true,
                  message: '收款账号不能为空！'
                }
              ],
              cb__accountName: [
                {
                  required: true,
                  message: '户名不能为空！'
                }
              ],
              cb__bank: [
                {
                  required: true,
                  message: '开户行不能为空！'
                }
              ],
              fidoc__warrantNo: [
                {
                  required: true,
                  message: '担保合同编号不能为空！'
                }
              ],
                fi__payAccountId: [
                    {
                        required: true,
                        message: '担保合同编号不能为空！'
                    }
                ],
            },
            customerOption:[],
            productOptions:[],
            proxyPersonOptions:[],
            houseColumns:[
                {
                    label: '权属',
                    field: 'pr__propertyOwner',

                },
                {
                    label: '位置',
                    field: 'pr__propertyLocation',

                },
                {
                    label: '用途',
                    field: 'pr__propertyUsage',

                },
                {
                    label: '面积',
                    field: 'pr__propertyArea',
                    unit:'㎡'

                },
                {
                    label: '产权证号',
                    field: 'pr__propertyCertNo',

                },
                {
                    label: '土地证',
                    field: 'pr__propertyLandNo',
                },
                {
                    label: '土地使用权面积',
                    field: 'pr__propertyLandArea',
                    unit:'㎡',
                    span:24
                },
            ],
          }
      },
      computed:{
          watchChecked() {
              return ((this.financingDetail||{}).properties||[]).map(item=>({
                  doc__exWarrant: item.doc__exWarrant,
              }))
          },
          watchChecked2() {
              return ((this.financingDetail||{}).properties||[]).map(item=>({
                  doc__pledgeFr: item.doc__pledgeFr,
              }))
          },
          watchChecked3() {
              return ((this.financingDetail||{}).properties||[]).map(item=>({
                  doc__pledgeTo: item.doc__pledgeTo,
              }))
          },
          docRemarks(){
              return this.financingDetail.properties[0].doc__remarks
          },
          disabledValue() {
            return this.financingDetail.fi__endDateFixed=='N' ? true : false
          },
        financingColumns(){
          return [
            {
              label: '贷款编号',
              field: 'fi__transactionNo',
              type: 'text',
            },
            {
              label: '贷款状态',
              field: 'fi__transactionStatus',
              component: 'el-select',
              options:[
                {
                  label:'待审核',
                  value:'Pending Approval',
                },
              ],
            },
            {
              label: '客户姓名',
              field: 'ba__customerName',
            },
            {
              label: '客户手机号',
              field: 'ba__customerContactNo',

            },
            {
              label: '渠道商',
              field: 'd__dealerName',
              span:24
            },
            {
              label: '贷款金额',
              field: 'fi__totalAmount',
              component: 'el-input',
              type: 'number',
              props: {
                step: 0.01
              },
              unit:'元',
              rules: [
                {
                  required: true,
                  message: '贷款金额不能为空',
                  trigger: 'change'
                },
              ]

            },
            {
              label: '贷款产品',
              field: 'p__productId',
              component: 'el-select',
              options: this.productOptions,
            },
            {
              label: '申请日期',
              field: 'fi__transactionDate',
              component: 'el-date-picker',
              valueFormat: 'yyyy-MM-dd',
              span:12
            },
            {
              label: '是否调整期限',
              field: 'fi__endDateFixed',
              component: 'el-checkbox',
              props: {
                'true-label':'Y',
                'false-label':'N'
              }

            },
            {
              label: '开始日期',
              field: 'fi__startDate',
              component: 'el-date-picker',
              valueFormat: 'yyyy-MM-dd',

            },
            {
              label: '结束日期',
              field: 'fi__endDate',
              component: 'el-date-picker',
              valueFormat: 'yyyy-MM-dd',
              disabled: this.disabledValue
            },
            /*{
              label: '贷款比例（%）',
              field: 'ct__financingRatio',
              component: 'el-input',
              type: 'number',

            },*/
            /*{
              label: '服务费',
              field: 'fi__lendingFee',
              component: 'el-input',
              type: 'number',
              props: {
                step: 0.01
              }

            },*/

            {
              label: '贷款合同利率',
              field: 'fi__interestRate',
              component: 'el-input',
              type: 'number',
              props: {
                step: 0.01
              },
              unit:this.unit

            },
            {
              label: '留存收益率',
              field: 'dfi__interestRate',
              component: 'el-input',
              type: 'number',
              props: {
                step: 0.01
              },
              unit:this.unit2

            },

            {
              label: '罚息复利率',
              field: 'fi__penaltyInterestRate',
              component: 'el-input',
              type: 'number',
              props: {
                step: 0.01
              },
              unit:'%（年利率）',

            },

            /*{
              label: '利息收取节点',
              field: 'fi__interestPayTime',
              component: 'el-select',
              options:[
                {
                  label:'还款时收取',
                  value:'还款时收取',
                }
              ],
            },
            {
              label: '费用收取节点',
              field: 'fi__lendingFeePayTime',
              component: 'el-select',
              options:[
                {
                  label:'还款时收取',
                  value:'还款时收取',
                }
              ],
            },*/
            {
              label: '还款期数（月）',
              field: 'fi__repaymentCount',
              component: 'el-input',
              type: 'number',
            },
            {
              label: '还款方式',
              field: 'fi__repaymentFormula',
              component: 'el-select',
              options:[
                {
                  label: '等额本息',
                  value: 'DEBX'
                },
                {
                  label: '先息后本',
                  value: 'XXHB'
                },
              ],
              span:24
            },

            {
              label: '贷款用途',
              field: 'ex__purpose',
              component: 'el-input',
              type:"textarea",
              span:24
            },
            {
              label: '收款账号',
              field: 'cb__accountNo',
              component: 'el-input',
              type: 'text',
            },
            {
              label: '户名',
              field: 'cb__accountName',
            },
            {
              label: '开户行',
              field: 'cb__bank',
              component: 'el-input',
              type: 'text',
              span:12
            },
           /* {
              label: '担保合同编号',
              field: 'fidoc__warrantNo',
              component: 'el-input',
              type: 'text',
              span:12
            },*/
              {
                  label: '代理人',
                  field: 'fi__proxyPersonName',
                  component: 'el-select',
                  options: this.proxyPersonOptions,
                  span:12
              },
              {
                  label: '放款账户',
                  field: 'fi__payAccountId',
                  component: 'el-select',
                  props:{
                    style:"width:50%"
                  },
                  options: this.payAccountOptions,
                  span:24
              },
          ]
        },
        fileList: {
          get() {
            return this.financingDetail.files
          },
          set(newVal) {
            this.financingDetail.files = newVal.map(item => Object.assign(item, {
                'pa__fileId': item.fileId,
                'pa__checked': true
              })
            )
          }
        },
          /*filterParams() {
              return {
                  pageSize: this.pageSizeMatching,
                  pageOffset: (this.pageMatching - 1) * this.pageSizeMatching,
              }
          }*/
      },
      watch:{
          watchChecked: function (newVal) {

              this.onChange()
          },
          watchChecked2: function () {

              this.onChange2()
          },
          watchChecked3: function () {

              this.onChange3()
          },
          docRemarks:function () {
              this.onChangeRemarks()
          },
          'financingDetail.fidoc__splitWarrant':function () {
              this.onChange()
              this.onChange2()
              this.onChange3()
          },
          'financingDetail.fi__repaymentCount':function () {
            if(this.financingDetail.fi__repaymentCount){
              if(this.financingDetail.fi__startDate){
                if(this.financingDetail.fi__endDateFixed=='N')
                this.financingDetail.fi__endDate = this.$moment(this.financingDetail.fi__startDate).add(parseInt(this.financingDetail.fi__repaymentCount),'M').format('YYYY-MM-DD')
              }
            }
          },
          'financingDetail.fi__startDate':function () {
            if(this.financingDetail.fi__repaymentCount){
              if(this.financingDetail.fi__startDate){
                if(this.financingDetail.fi__endDateFixed=='N')
                this.financingDetail.fi__endDate = this.$moment(this.financingDetail.fi__startDate).add(parseInt(this.financingDetail.fi__repaymentCount),'M').format('YYYY-MM-DD')
              }
            }
          },
        'financingDetail.fi__endDate':function () {
            if(this.financingDetail.fi__startDate){
              if(this.financingDetail.fi__endDate){
                if(this.financingDetail.fi__endDateFixed=='Y'){
                  let date1 = this.financingDetail.fi__startDate.toString().split('-')
                  let date2 = this.financingDetail.fi__endDate.toString().split('-')
                  this.financingDetail.fi__repaymentCount =  Math.abs((parseInt(date1[0]) * 12 + parseInt(date1[1])) - (parseInt(date2[0]) * 12 + parseInt(date2[1])))
                }
              }

            }
        },
        'financingDetail.fi__endDateFixed':function () {
          if(this.financingDetail.fi__repaymentCount){
            if(this.financingDetail.fi__startDate){
              if(this.financingDetail.fi__endDateFixed=='N')
                this.financingDetail.fi__endDate = this.$moment(this.financingDetail.fi__startDate).add(parseInt(this.financingDetail.fi__repaymentCount),'M').format('YYYY-MM-DD')
            }
          }
        },
          'financingDetail.p__productId':function (newVal) {
            if(this.productOptions.length>0) {
             // let lendingFee = (this.productOptions.filter(item => item.value == newVal)[0] || {}).p__lendingFee
              let interestRate = (this.productOptions.filter(item => item.value == newVal)[0] || {}).dp__interestRate
              let penaltyInterestRate = (this.productOptions.filter(item => item.value == newVal)[0] || {}).dp__penaltyInterestRate
              //let lendingFeeType = (this.productOptions.filter(item => item.value == newVal)[0] || {}).p__lendingFeeType
              let interestType = (this.productOptions.filter(item => item.value == newVal)[0] || {}).dp__interestType
              this.financingDetail.fi__interestRate = interestRate
              this.financingDetail.fi__penaltyInterestRate = penaltyInterestRate
              if (interestType == 'Yearly') {
                this.unit = "%（年利率）"
              }
              if (interestType == 'Daily') {
                this.unit = "%（日利率）"
              }
              if (interestType == 'Monthly') {
                this.unit = "%（月利率）"
              }
             /* if (lendingFeeType == 'Rate') {
                if (this.financingDetail.fi__totalAmount) {
                  this.financingDetail.fi__lendingFee = this.financingDetail.fi__totalAmount * lendingFee / 100
                }
              } else {
                this.financingDetail.fi__lendingFee = lendingFee
              }*/
              this.financingDetail.fi__interestType = interestType
            }
          },
        'financingDetail.fi__totalAmount':function (newVal) {
            if(this.financingDetail.p__productId) {
              //let lendingFee = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).p__lendingFee
              let interestRate = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).dp__interestRate
             // let lendingFeeType = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).p__lendingFeeType
              let interestType  = (this.productOptions.filter(item => item.value == this.financingDetail.p__productId)[0]||{}).dp__interestType

             /* if (lendingFeeType == 'Rate') {
                if (this.financingDetail.fi__totalAmount) {
                  this.financingDetail.fi__lendingFee = this.financingDetail.fi__totalAmount * lendingFee / 100
                }
              } else {
                this.financingDetail.fi__lendingFee = lendingFee
              }*/
            // this.financingDetail.fi__interestType = interestType
            }
        },
          'financingDetail.fi__proxyPersonName':function (newVal) {
              if(this.proxyPersonOptions.length>0) {
                  let contactNo = (this.proxyPersonOptions.filter(item => item.value == newVal)[0] || {}).p__contactNo
                  let IC = (this.proxyPersonOptions.filter(item => item.value == newVal)[0] || {}).p__IC

                  this.financingDetail.fi__proxyPersonContactNo = contactNo
                  this.financingDetail.fi__proxyPersonIC = IC
              }
          },
      },
        created() {
            this.onChange()
        },
      mounted() {
        this.data()
        // /this.getFinanceProductFangList()
        this.getProxyPersonList()
          this.getBankAccountList()
      },
      methods:{
          getBankAccountList: function () {
              xhr.getBankAccountList({},res=>{
                  try{
                      if(res.data.status == 'success') {
                          this.payAccountList = res.data.data||[]
                          this.payAccountOptions = this.payAccountList.map(item=>{
                              return {
                                  key: item['ba__accountId'],
                                  label: item['ba__bank']+'-'+item['ba__accountName']+'-'+item['ba__accountNo'],
                                  value: item['ba__accountId'],
                                  name: item['ba__bank'],
                                  accountName: item['ba__accountName'],
                                  accountNo: item['ba__accountNo'],
                              }
                          })
                      }
                  }catch (e) {

                  }
              })
          },

          getFinanceProductFangList: function () {
          xhr.getFinanceProductFangList(
            Object.assign({
              'd.dealerId':this.financingDetail.ba__dealerId
            }, {}, {}),
            res=> {
              try {
                this.productOptions = []
                this.productOptions = res.data.data.map(item=>{
                        return {
                            label: item.p__productName,
                            value:item.p__productId,
                            'dp__interestRate':item.dp__interestRate,
                            'dp__interestType':item.dp__interestType,
                            'p__productName':item.p__productName,
                            'dp__penaltyInterestRate':item.dp__penaltyInterestRate,
                        }

                })
                this.customerColumns[13].options = this.productOptions||[]
                //console.log( this.productOptions  )
              }catch(e){

              }
            })

        },
          getProxyPersonList: function () {
            xhr.getProxyPersonList(
              Object.assign({pageSize:0}, {},{}),
              res=> {
                  try {
                      this.proxyPersonOptions = []
                      this.proxyPersonOptions = res.data.data.map(item=>{
                          return {
                              label: item.p__name+(item.p__contactNo?("-"+item.p__contactNo):''),
                              value:item.p__name,
                              'p__contactNo':item.p__contactNo,
                              'p__IC':item.p__IC,
                          }

                      })
                      this.customerColumns[27].options = this.proxyPersonOptions||[]
                  }catch(e){

                  }
              })

            },

        data : function () {
          xhr.getApplyingCustomerFang({
            't.applicationId': this.$route.query['applicationId']
          }, res=>{
            try{
              if(res.data.status == 'success') {
                  let financingDetail = res.data.data
                  if( res.data.data.t__financingNo){
                      financingDetail.fi__transactionNo =  financingDetail.t__financingNo
                  }
                  financingDetail = Object.assign(
                      {},
                  res.data.data||{},
                  {
                    cb__accountName: res.data.data.ba__customerName||'',
                    fi__interestRate: res.data.data.ba__interestRate||0,
                   /* fi__interestRate: res.data.data.ba__interestRate||0,*/
                    fi__penaltyInterestRate: res.data.data.dp__penaltyInterestRate||'',
                    p__productId: res.data.data.ba__productId||'',
                    fi__repaymentCount: res.data.data.ba__repaymentCount||0,
                    dfi__interestRate : res.data.data.dp__dealerInterestRate||0,
                    dfi__interestType : res.data.data.dp__dealerInterestType||0,
                    cb__accountNo:res.data.data.ba__customerBankAccountNo||'',
                    cb__bank:res.data.data.ba__customerBankName||'',
                    ex__purpose:'',
                    fi__totalAmount:res.data.data.ba__amount||'',
                    fidoc__splitWarrant:res.data.data.fidoc__splitWarrant||'N',
                    fi__transactionStatus:res.data.data.fi__transactionStatus||'Pending Approval',
                      fi__transactionNo:res.data.data.fi__transactionNo||'提交时生成',
                      fi__transactionDate:'',
                      fi__endDateFixed:'N',
                      fi__startDate:'',
                      fi__endDate:'',
                      fi__repaymentFormula:'',
                      fi__interestType:'Yearly',
                      fi__interestPayTime:'还款时收取',
                      fi__lendingFeePayTime:'还款时收取',
                      fi__currencyCode:'CNY',
                      fi__lendingFee:'0',
                      files:[],
                      fi__proxyPersonName:'',
                      fi__proxyPersonContactNo:'',
                      fi__remarks:'',
                  }
                  )
                financingDetail.properties.forEach(item=>{
                    item.doc__exWarrant = ""
                    item.doc__warrantNo = ""
                    item.doc__pledgeFr = null
                    item.doc__pledgeTo = null

                    if(item.asm__pledgeGrade=='二抵'){
                        item.doc__remarks ='余额抵押'
                    }else{
                        item.doc__remarks = ''
                    }
                })


                  financingDetail.properties.forEach(item=>{
                      item.pr__propertyOwner =""
                      item.pr__owners.forEach(itemP=>{
                          item.pr__propertyOwner = item.pr__propertyOwner+","+itemP.ow__ownerName
                      })
                      item.pr__propertyOwner = item.pr__propertyOwner.substr(1);
                  })

                  this.financingDetail = financingDetail
                  if( this.financingDetail.ba__dealerId) {
                      this.getFinanceProductFangList()
                  }
                  this.remarksRules.fi__remarks[0].required = true
                let interestType =  this.financingDetail.fi__interestType

                if(interestType=='Yearly'){
                  this.unit="%（年利率）"
                }
                if(interestType=='Daily'){
                  this.unit="%（日利率）"
                }
                if(interestType=='Monthly') {
                  this.unit = "%（月利率）"
                }
                if(this.financingDetail.dfi__interestType=='Yearly'){
                  this.unit2="%（年利率）"
                }
                if(this.financingDetail.dfi__interestType=='Daily'){
                  this.unit2="%（日利率）"
                }
                if(this.financingDetail.dfi__interestType=='Monthly'){
                  this.unit2="%（月利率）"
                }

              }
            }catch(e){}
          })

        },
        onSubmit :function () {
          this.$refs.formBuildName1.$refs.formSubmit1.validate(valid1=> {

              if (valid1) {
                  let proxyPersonContactNo = (this.proxyPersonOptions.filter(item => item.value == this.financingDetail.fi__proxyPersonName)[0] || {}).p__contactNo
                  this.financingDetail.fi__proxyPersonContactNo = proxyPersonContactNo
                    let value = true
                    var m =1
                  this.financingDetail.properties.forEach(item=>{
                      if(value){
                          if(item.doc__warrantNo){

                          }  else{
                              this.$alert('抵押物'+m+'担保合同编号未填写')
                              value=false
                          }
                          if(item.doc__pledgeFr){

                          }  else{
                              this.$alert('抵押物'+m+'抵押期限开始日期未填写')
                              value=false
                          }
                          if(item.doc__pledgeTo){

                          }  else{
                              this.$alert('抵押物'+m+'抵押期限结束日期未填写')
                              value=false
                          }
                      }

                      if(item.asm__pledgeGrade=='二抵'){
                          if(item.doc__remarks.trim().length>0){

                          }else{
                              this.$alert('备注未填写')
                              value = false
                          }
                      }


                  })

                  if(value){
                      xhr.updateCreateFinancing(
                          this.financingDetail,
                          res=> {
                              try{
                                  if(res.data.status == 'success') {
                                      this.$router.push({
                                          path: 'List'
                                      })

                                  }else{

                                      this.$message.error(res.data.msgs[0].text)
                                  }
                              }catch (e) {

                                  this.$message.error(error.msgs[0].text)

                              }
                          }
                      )
                  }


              }
          })

        },
          dataRelaod:function () {
              this.selectKeys = -1
          },
          onSelect:function (key) {
           this.dialogVisible = true
              xhr.getWarrant(
                  Object.assign({
                      'c.customerIC':  this.financingDetail.ba__customerIC,
                      pageSize:0,
                  }, {}, xmlBuildQuery(this.filtersMatching)),
                   res=>{
                  try{
                    this.selectKeys = key
                      this.financing = res.data
                  }catch (e) {

                      this.$message.error(error.msgs[0].text)

                  }
              })
          },

          onChange:function () {
           //alert('111')
              for(var key=0;key<((this.financingDetail||{}).properties||[]).length;key++){
                  if(this.financingDetail.fidoc__splitWarrant=='N'&&key!=0){
                      ((this.financingDetail||{}).properties||[])[key].doc__exWarrant =   ((this.financingDetail||{}).properties||[])[0].doc__exWarrant
                  }
                  if(this.financingDetail.fidoc__splitWarrant=='Y'){
                      if(  ((this.financingDetail||{}).properties||[])[key].doc__exWarrant=='N'){
                          if(((this.financingDetail||{}).properties||[]).length>1){
                              ((this.financingDetail||{}).properties||[])[key].doc__warrantNo= this.financingDetail.fi__transactionNo.replace('个','高抵').replace('号','-'+(key+1)+'号')
                          }else{
                              ((this.financingDetail||{}).properties||[])[key].doc__warrantNo= this.financingDetail.fi__transactionNo.replace('个','高抵')
                          }

                      }else{
                          ((this.financingDetail||{}).properties||[])[key].doc__warrantNo= ''
                      }
                  }else{
                      if(  ((this.financingDetail||{}).properties||[])[key].doc__exWarrant=='N'){
                          ((this.financingDetail||{}).properties||[])[key].doc__warrantNo= this.financingDetail.fi__transactionNo.replace('个','高抵')

                      }else{
                          ((this.financingDetail||{}).properties||[])[key].doc__warrantNo= ''
                      }
                  }

              }
          },
          onChange2:function () {
              for(var key=0;key<((this.financingDetail||{}).properties||[]).length;key++){

                  if(this.financingDetail.fidoc__splitWarrant=='N'&&key!=0){
                      ((this.financingDetail||{}).properties||[])[key].doc__pledgeFr =   ((this.financingDetail||{}).properties||[])[0].doc__pledgeFr
                  }else{

                  }

              }
          },
          onChange3:function () {
              for(var key=0;key<((this.financingDetail||{}).properties||[]).length;key++){

                  if(this.financingDetail.fidoc__splitWarrant=='N'&&key!=0){
                      ((this.financingDetail||{}).properties||[])[key].doc__pledgeTo =   ((this.financingDetail||{}).properties||[])[0].doc__pledgeTo
                  }else{

                  }

              }
          },
          onChangeRemarks:function () {
            if(((this.financingDetail||{}).properties||[]).length>1){
                for(var key=1;key<((this.financingDetail||{}).properties||[]).length;key++){
                    if(this.financingDetail.fidoc__splitWarrant=='N'&&key!=0){
                        ((this.financingDetail||{}).properties||[])[key].doc__remarks =   ((this.financingDetail||{}).properties||[])[0].doc__remarks
                    }
                }
            }
          },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/FinancingAdd.vue